module.exports = __webpack_public_path__ + "img/blog-2.58c8e0a2.jpg";